import React from "react";
import { NavLink } from "react-router-dom";
import { Nav, Collapse } from "reactstrap";
import PerfectScrollbar from "perfect-scrollbar";

var ps;

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.getCollapseStates(props.routes);
  }

  getCollapseStates = (routes) => {
    let initialState = {};
    routes.map((prop) => {
      if (prop.collapse) {
        initialState = {
          [prop.state]: this.getCollapseInitialState(prop.views),
          ...this.getCollapseStates(prop.views),
          ...initialState,
          employeeProfile: null,
          isLoaded: false,
          isAdmin: this.props.isAdmin,
          isEmployee: this.props.isEmployee,
          isCustomerService: this.props.isCustomerService,
        };
      }
      return null;
    });
    return initialState;
  };

  getCollapseInitialState(routes) {
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse && this.getCollapseInitialState(routes[i].views)) {
        return true;
      } else if (window.location.pathname === routes[i].layout + routes[i].path) {
        return true;
      }
    }
    return false;
  }

  createLinks = (routes) => {
    return routes.map((prop, key) => {
      if (prop.redirect) {
        return null;
      }
      if (prop.invisible) return null;

      if (this.state.isAdmin) {
        if (!prop.adminView) {
          return null;
        }
      }
      if (this.state.isCustomerService) {
        if (!prop.customerServiceView) {
          return null;
        }
      }
      if (this.state.isEmployee) {
        if (!prop.employeeView) {
          return null;
        }
      }

      if (prop.collapse) {
        var st = {};
        st[prop["state"]] = !this.state[prop.state];
        return (
          <li
            className={this.getCollapseInitialState(prop.views) ? "active" : ""}
            key={key}
          >
            <a
              href="#pablo"
              data-toggle="collapse"
              aria-expanded={this.state[prop.state]}
              onClick={(e) => {
                e.preventDefault();
                this.setState(st);
              }}
            >
              {prop.icon !== undefined ? (
                <>
                  <i className={prop.icon} />
                  <p>
                    {prop.name}
                    <b className="caret" />
                  </p>
                </>
              ) : (
                <>
                  <span className="sidebar-mini-icon">{prop.mini}</span>
                  <span className="sidebar-normal">
                    {prop.name}
                    <b className="caret" />
                  </span>
                </>
              )}
            </a>
            <Collapse isOpen={this.state[prop.state]}>
              <ul className="nav">{this.createLinks(prop.views)}</ul>
            </Collapse>
          </li>
        );
      }
      return (
        <li className={this.activeRoute(prop.layout + prop.path)} key={key}>
          <NavLink
            to={prop.layout + prop.path}
            exact
            activeClassName="active"
          >
            {prop.icon !== undefined ? (
              <>
                <i className={prop.icon} />
                <p>{prop.name}</p>
              </>
            ) : (
              <>
                <span className="sidebar-mini-icon">{prop.mini}</span>
                <span className="sidebar-normal">{prop.name}</span>
              </>
            )}
          </NavLink>
        </li>
      );
    });
  };

  activeRoute = (routeName) => {
    return this.props.location.pathname === routeName ? "active" : "";
  };

  initPerfectScrollbar() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.refs.sidebar, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
  }

  componentDidMount() {
    fetch(global.config.server.connection.url + "/api/Employee/EmployeeProfile", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.access_token.replace(/['"]+/g, ""),
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({
            employeeProfile: result,
            isLoaded: true,
          });

          this.initPerfectScrollbar();
        },
        (error) => {
          // handle error
        }
      );
  }

  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
  }

  logOut() {
    sessionStorage.setItem("access_token", "");
  }

  render() {
    const { isLoaded, employeeProfile } = this.state;

    if (!isLoaded) {
      return <p>Loading menu</p>;
    }

    sessionStorage.setItem("oldUserId", employeeProfile.oldUserId); //for use in other components

    let hrefLink = "#";

    return (
      <div
        className="sidebar"
        data-color={this.props.bgColor}
        data-active-color={this.props.activeColor}
      >
        <div className="logo">
          <a href="/admin/welcome">
            <div className="logo-img">
            <svg width="70%" viewBox="0 0 126 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M62.725 29L58.875 22.2H57.225V29H53.725V11.55H60.275C61.625 11.55 62.775 11.7917 63.725 12.275C64.675 12.7417 65.3833 13.3833 65.85 14.2C66.3333 15 66.575 15.9 66.575 16.9C66.575 18.05 66.2417 19.0917 65.575 20.025C64.9083 20.9417 63.9167 21.575 62.6 21.925L66.775 29H62.725ZM57.225 19.575H60.15C61.1 19.575 61.8083 19.35 62.275 18.9C62.7417 18.4333 62.975 17.7917 62.975 16.975C62.975 16.175 62.7417 15.5583 62.275 15.125C61.8083 14.675 61.1 14.45 60.15 14.45H57.225V19.575ZM74.8906 29.225C73.5573 29.225 72.3573 28.9333 71.2906 28.35C70.224 27.75 69.3823 26.9083 68.7656 25.825C68.1656 24.7417 67.8656 23.4917 67.8656 22.075C67.8656 20.6583 68.174 19.4083 68.7906 18.325C69.424 17.2417 70.2823 16.4083 71.3656 15.825C72.449 15.225 73.6573 14.925 74.9906 14.925C76.324 14.925 77.5323 15.225 78.6156 15.825C79.699 16.4083 80.549 17.2417 81.1656 18.325C81.799 19.4083 82.1156 20.6583 82.1156 22.075C82.1156 23.4917 81.7906 24.7417 81.1406 25.825C80.5073 26.9083 79.6406 27.75 78.5406 28.35C77.4573 28.9333 76.2406 29.225 74.8906 29.225ZM74.8906 26.175C75.524 26.175 76.1156 26.025 76.6656 25.725C77.2323 25.4083 77.6823 24.9417 78.0156 24.325C78.349 23.7083 78.5156 22.9583 78.5156 22.075C78.5156 20.7583 78.1656 19.75 77.4656 19.05C76.7823 18.3333 75.9406 17.975 74.9406 17.975C73.9406 17.975 73.099 18.3333 72.4156 19.05C71.749 19.75 71.4156 20.7583 71.4156 22.075C71.4156 23.3917 71.7406 24.4083 72.3906 25.125C73.0573 25.825 73.8906 26.175 74.8906 26.175ZM91.883 29L87.183 23.1V29H83.683V10.5H87.183V21.025L91.833 15.15H96.383L90.283 22.1L96.433 29H91.883ZM110.158 21.775C110.158 22.275 110.124 22.725 110.058 23.125H99.9326C100.016 24.125 100.366 24.9083 100.983 25.475C101.599 26.0417 102.358 26.325 103.258 26.325C104.558 26.325 105.483 25.7667 106.033 24.65H109.808C109.408 25.9833 108.641 27.0833 107.508 27.95C106.374 28.8 104.983 29.225 103.333 29.225C101.999 29.225 100.799 28.9333 99.7326 28.35C98.6826 27.75 97.8576 26.9083 97.2576 25.825C96.6743 24.7417 96.3826 23.4917 96.3826 22.075C96.3826 20.6417 96.6743 19.3833 97.2576 18.3C97.841 17.2167 98.6576 16.3833 99.7076 15.8C100.758 15.2167 101.966 14.925 103.333 14.925C104.649 14.925 105.824 15.2083 106.858 15.775C107.908 16.3417 108.716 17.15 109.283 18.2C109.866 19.2333 110.158 20.425 110.158 21.775ZM106.533 20.775C106.516 19.875 106.191 19.1583 105.558 18.625C104.924 18.075 104.149 17.8 103.233 17.8C102.366 17.8 101.633 18.0667 101.033 18.6C100.449 19.1167 100.091 19.8417 99.9576 20.775H106.533ZM120.087 27.025C119.704 27.6583 119.079 28.1917 118.212 28.625C117.346 29.0417 116.412 29.25 115.412 29.25C114.546 29.25 113.762 29.075 113.062 28.725C112.362 28.375 111.812 27.8917 111.412 27.275C111.012 26.6583 110.812 25.95 110.812 25.15C110.812 23.8667 111.287 22.8167 112.237 22C113.204 21.1833 114.646 20.775 116.562 20.775H120.087C120.054 19.8917 119.796 19.1917 119.312 18.675C118.846 18.1417 118.196 17.875 117.362 17.875C116.629 17.875 116.021 18.075 115.537 18.475C115.054 18.8583 114.746 19.4 114.612 20.1H111.112C111.279 19.1 111.637 18.2083 112.187 17.425C112.754 16.625 113.487 16.0083 114.387 15.575C115.304 15.125 116.329 14.9 117.462 14.9C118.629 14.9 119.679 15.1417 120.612 15.625C121.562 16.1083 122.304 16.8 122.837 17.7C123.371 18.6 123.637 19.6583 123.637 20.875V29H120.087V27.025ZM116.437 26.425C117.021 26.425 117.587 26.3 118.137 26.05C118.704 25.8 119.171 25.425 119.537 24.925C119.904 24.425 120.087 23.8333 120.087 23.15V23.05H116.762C115.962 23.05 115.362 23.2083 114.962 23.525C114.579 23.8417 114.387 24.2583 114.387 24.775C114.387 25.275 114.562 25.675 114.912 25.975C115.279 26.275 115.787 26.425 116.437 26.425Z" fill="currentColor"></path>
                <path d="M37.1155 7.9344C30.2967 8.20668 17.3455 19.1397 22.84 25.2747C25.7442 27.713 29.2763 27.3198 30.9344 24.1047C30.9344 24.1047 37.0231 28.4608 28.9673 34.33C20.9116 40.1993 10.3458 35.4835 12.808 23.152C15.0842 14.9471 24.4098 9.77977 27.6281 8.52132C27.6281 8.52132 27.0792 8.17998 25.2655 8.91005C22.0805 10.1922 19.9221 9.53774 19.1077 8.87832C20.2831 9.27734 20.3802 9.47445 24.5606 7.28291C27.905 5.52968 30.0513 6.47935 30.7677 7.10551C33.7934 6.29453 36.3012 7.27498 37.1155 7.9344Z" fill="url(#paint0_linear)"></path>
                <path d="M31.2574 16.9758C32.7435 23.41 28.743 29.833 22.3222 31.3222C15.9013 32.8113 9.49154 28.8026 8.0055 22.3684C6.52163 15.9437 10.5081 9.5301 16.9124 8.02868C16.3931 7.56187 15.9115 7.0804 15.5998 6.75961C15.4912 6.64786 15.5961 6.46148 15.7489 6.49157C16.7872 6.69614 19.1578 7.06373 20.4215 6.46073C20.8449 6.25867 21.3305 5.92997 21.9142 5.53488L21.9142 5.53487C23.3817 4.54159 25.469 3.12874 28.7469 2.25378C24.7316 0.141504 19.9706 -0.594171 15.2059 0.510863C4.64532 2.96008 -1.93435 13.5244 0.509807 24.1068C2.95396 34.6893 13.4964 41.2826 24.057 38.8334C34.6176 36.3842 41.1973 25.8199 38.7531 15.2374C38.4379 13.8725 37.9879 12.5739 37.4205 11.3526C33.2311 12.3333 30.6985 15.6308 30.6985 15.6308C30.9272 16.0184 31.115 16.3589 31.2574 16.9758Z" fill="currentColor"></path>
                <defs>
                  <linearGradient id="paint0_linear" x1="16.0315" y1="23.6066" x2="25.2225" y2="6.2453" gradientUnits="userSpaceOnUse">
                    <stop stopColor="currentColor"></stop>
                    <stop offset="1" stopColor="currentColor"></stop>
                  </linearGradient>
                </defs>
              </svg>
            </div>
          </a>
        </div>

        <div className="sidebar-wrapper" ref="sidebar">
          <div className="user">
            <div className="photo">
              <img src={"data:image/png;base64, " + employeeProfile.userImage} alt="Avatar" />
            </div>
            <div className="info">
              <a
                href={hrefLink}
                data-toggle="collapse"
                aria-expanded={this.state.openAvatar}
                onClick={() => this.setState({ openAvatar: !this.state.openAvatar })}
              >
                <span>
                  {employeeProfile.userName}
                  <b className="caret" />
                </span>
              </a>
              <Collapse isOpen={this.state.openAvatar}>
                <ul className="nav">
                  <li>
                    <NavLink to="/admin/user-profile" exact activeClassName="active">
                      <span className="sidebar-mini-icon">MP</span>
                      <span className="sidebar-normal">Min Profil</span>
                    </NavLink>
                  </li>

                  <li>
                    <NavLink to="/admin/changepwd" exact activeClassName="active">
                      <span className="sidebar-mini-icon">EP</span>
                      <span className="sidebar-normal">Endre passord</span>
                    </NavLink>
                  </li>

                  <li>
                    <NavLink to="/" onClick={this.logOut} exact activeClassName="active">
                      <span className="sidebar-mini-icon">LU</span>
                      <span className="sidebar-normal">Logg Ut</span>
                    </NavLink>
                  </li>
                </ul>
              </Collapse>
            </div>
          </div>

          <Nav>{this.createLinks(this.props.routes)}</Nav>
        </div>
      </div>
    );
  }
}

export default Sidebar;
